<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            :max-width="!(recalculationForm || calculationForm) ? '1000px' : '1280px'"
            transition="false"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("pattern") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-0">
                    <v-layout row wrap v-if="!(recalculationForm || calculationForm)">
                        <v-flex xs12 md4 pl-3 pr-2>
                            <v-text-field
                                class="mt-0"
                                v-model="name"
                                :label="`${$t('name')} *`"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md2 px-2>
                            <!--
                            <v-text-field
                                v-model="species"
                                :label="`${$t('speciesAlt')}`"
                                readonly
                            ></v-text-field>
                            -->
                            <v-select
                                class="mt-0"
                                :value="speciesId"
                                :items="speciesFiltered"
                                item-text="name"
                                item-value="id"
                                :label="$t('speciesAlt')"
                                @input="inputSpecies"
                                v-if="speciesFiltered.length > 0"
                            ></v-select>
                            <v-alert type="warning" value="true" v-else>{{ $t("noSpeciesSelectedWarning") }}</v-alert>
                        </v-flex>

                        <v-flex xs12 md3 px-2>
                            <v-select
                                class="mt-0"
                                :label="$t('lumberGroup')"
                                :items="groups"
                                item-text="name"
                                item-value="id"
                                v-model="selectedGroupId"
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 md3 pl-2 pr-3>
                            <v-text-field
                                class="mt-0"
                                v-model="dU"
                                :label="`${$t('diameterU')}, ${$t('cm')}`"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap pb-1>
                        <v-flex :class="{'xs5': !(recalculationForm || calculationForm), 'xs4': recalculationForm || calculationForm}" px-3>
                            <v-switch
                                class="mt-0"
                                v-model="symmetricSideBoards"
                                :label="`${$t('symmetricSideBoards')}`"
                                hide-details
                            ></v-switch>
                        </v-flex>
                        <v-flex :class="{'xs5': !(recalculationForm || calculationForm), 'xs4': recalculationForm || calculationForm}" px-3>
                            <v-switch
                                class="mt-0"
                                v-model="splittedPattern"
                                :label="`${$t('boardsCuttingPossibility')}`"
                                hide-details
                            ></v-switch>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 :class="{'md3': !(recalculationForm || calculationForm), 'md2': recalculationForm || calculationForm}">
                            <v-card class="elevation-0">
                                <v-card-title class="pb-1">
                                    <span class="font-weight-black ml-2">{{ $t("centralBoards") }}</span>
                                </v-card-title>
                                <v-card-text class="dense px-1 ml-2" >
                                    <template>
                                        <v-flex class="v-scrollable dimensions-list">
                                            <v-data-table
                                                v-model="centralBoardsSelected"
                                                item-key="uid"
                                                :headers="boardsHeader"
                                                :items="boardsCentralFiltered"
                                                :rows-per-page-items="[100]"
                                                hide-actions
                                                class="dense-table boards-table drag_drop"
                                            >
                                                <template v-slot:items="props">
                                                    <tr
                                                        :data-board="props.item.id"
                                                        draggable="true"
                                                        class="draggable central_board"
                                                    >
                                                        <!--
                                                        <td>
                                                            <v-checkbox
                                                                v-model="props.selected"
                                                                primary
                                                                hide-details
                                                            ></v-checkbox>
                                                        </td>
                                                        -->
                                                        <td>{{ props.item.size }}</td>
                                                        <td>{{ props.item.sawSize }}</td>
                                                        <!--
                                                        <td>{{ props.item.length }}</td>
                                                        -->
                                                        <!--
                                                        <td>{{ props.item.price }}</td>
                                                        -->
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-flex>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 :class="{'md6': !(recalculationForm || calculationForm), 'md5': recalculationForm || calculationForm}" px-1 pb-1>
                            <v-sheet id="drop_area" class="d-flex drop-area">
                                <v-sheet
                                    class="d-flex pattern-container"
                                    xs12 lg6
                                    elevation="0"
                                    ref="PatternPreview"
                                >
                                    <pattern-vue
                                        :pattern="pattern"
                                        :sizeNominal="sizeNominal"
                                        :falseCore="falseCore"
                                        :ellipseRatio="ellipseRatio"
                                        :rotate="rotate"
                                        :logDTop="dTop"
                                        :logDBottom="dBottom"
                                        :horizontalSaw="horizontalSaw"
                                        :showDiameter="showPatternDiameter"
                                        :showCross="showAxes"
                                        :isDraggable="true"
                                        :curvatureHeight="logLength * curvature * 9.8"
                                        :symmetric="symmetricSideBoards"
                                        :patternSolidBG="patternSolidBG"
                                        :rotatePattern="rotatePattern"
                                        sideSize="430"
                                        ref="PatternVue"
                                    />
                                </v-sheet>

                                <v-sheet class="drop transparent-bg">
                                    <v-layout row wrap>
                                        <v-flex xs3 class="drag_drop side_board vertical left">
                                            <v-icon v-if="splittedPattern" class="up left">mdi-arrow-up-bold-circle-outline</v-icon>
                                            <v-icon :class="{'down left': splittedPattern, 'left central': !splittedPattern}">mdi-arrow-left-bold-circle-outline</v-icon>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-layout row wrap>
                                                <v-flex xs12 style="height: 25%;" class="drag_drop side_board horizontal up">
                                                    <v-icon :class="{'up left': splittedPattern, 'up central': !splittedPattern}">mdi-arrow-up-bold-circle-outline</v-icon>
                                                    <v-icon v-if="splittedPattern" class="up right">mdi-arrow-right-bold-circle-outline</v-icon>
                                                </v-flex>
                                                <v-flex xs12 style="height: 50%;" class="drag_drop central_board">
                                                    <v-icon :class="{'up left': splittedPattern, 'up central': !splittedPattern}">mdi-arrow-up-bold-circle-outline</v-icon>
                                                    <v-icon :class="{'down left': splittedPattern, 'down central': !splittedPattern}">mdi-arrow-down-bold-circle-outline</v-icon>
                                                    <v-icon v-if="splittedPattern" class="up right">mdi-arrow-right-bold-circle-outline</v-icon>
                                                    <v-icon v-if="splittedPattern" class="down right">mdi-arrow-right-bold-circle-outline</v-icon>
                                                </v-flex>
                                                <v-flex xs12 style="height: 25%;" class="drag_drop side_board horizontal down">
                                                    <v-icon :class="{'down left': splittedPattern, 'down central': !splittedPattern}">mdi-arrow-down-bold-circle-outline</v-icon>
                                                    <v-icon v-if="splittedPattern" class="down right">mdi-arrow-right-bold-circle-outline</v-icon>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs3 class="drag_drop side_board vertical right">
                                            <v-icon v-if="splittedPattern" class="up right">mdi-arrow-up-bold-circle-outline</v-icon>
                                            <v-icon :class="{'down right': splittedPattern, 'right central': !splittedPattern}">mdi-arrow-right-bold-circle-outline</v-icon>
                                        </v-flex>
                                    </v-layout>
                                </v-sheet>
                            </v-sheet>
                        </v-flex>

                        <v-flex xs12 :class="{'md3': !(recalculationForm || calculationForm), 'md2': recalculationForm || calculationForm}">
                            <v-card class="elevation-0">
                                <v-card-title class="pb-1">
                                    <span class="font-weight-black">{{ $t("sideBoards") }}</span>
                                </v-card-title>
                                <v-card-text class="dense px-1">
                                    <template>
                                        <v-flex class="v-scrollable dimensions-list">
                                            <v-data-table
                                                v-model="sideBoardsSelected"
                                                item-key="uid"
                                                :headers="boardsHeader"
                                                :items="boardsSideFiltered"
                                                :rows-per-page-items="[100]"
                                                hide-actions
                                                class="dense-table boards-table drag_drop"
                                            >
                                                <template v-slot:items="props">
                                                    <tr
                                                        :data-board="props.item.id"
                                                        draggable="true"
                                                        class="draggable side_board"
                                                    >
                                                        <!--
                                                        <td>
                                                            <v-checkbox
                                                                v-model="props.selected"
                                                                primary
                                                                hide-details
                                                            ></v-checkbox>
                                                        </td>
                                                        -->
                                                        <td>{{ props.item.size }}</td>
                                                        <td>{{ props.item.sawSize }}</td>
                                                        <!--
                                                        <td>{{ props.item.length }}</td>
                                                        -->
                                                        <!--
                                                        <td>{{ props.item.price }}</td>
                                                        -->
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-flex>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <template v-if="recalculationForm || calculationForm">
                            <v-flex xs12 md3 class="mb-2 left-border pl-1">
                                <div class="subheading font-weight-black pl-2 pb-2">{{ $t("settings") }}</div>
                                <v-layout flat row v-if="useUserVolumeInput">
                                    <v-flex xs6 mx-2>
                                        <v-text-field
                                            :label="$t('logVolume')"
                                            :suffix="`${$t('m')}3`"
                                            :value="volume"
                                            @change="volume = $event"
                                            class="mt-0"
                                            type="number"
                                            :rules="[rules.requiredNumAllowZero]"
                                            flat
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs10 ml-2>
                                        <span class="pl-0">{{ $t("diameterTop") }}, {{ $t("mm") }}</span>
                                        <v-slider
                                            v-model="dTop"
                                            :min="50"
                                            :max="999"
                                            class="pr-2 mt-0"
                                        ></v-slider>
                                    </v-flex>
                                    <v-flex xs2 mt-2 mr-2>
                                        <v-text-field
                                            :value="dTop"
                                            @change="dTop = $event"
                                            class="mt-0"
                                            type="number"
                                            :rules="[rules.required, rules.dTop]"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs10 ml-2>
                                        <span class="pl-0">{{ $t("length") }}, {{ $t("m") }}</span>
                                        <v-slider
                                            v-model="logLength"
                                            :min="1.0"
                                            :max="10.0"
                                            :step="0.1"
                                            class="pr-2 mt-0"
                                        ></v-slider>
                                    </v-flex>
                                    <v-flex xs2 mt-2 mr-2>
                                        <v-text-field
                                            :value="logLength"
                                            @change="logLength = $event"
                                            class="mt-0"
                                            type="number"
                                            :rules="[rules.required, rules.length]"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row v-if="!useUserVolumeInput && !useStdTable">
                                    <v-flex xs10 ml-2>
                                        <span class="pl-0">{{ $t("taper") }}, {{ $t("mm")}}/{{ $t("m") }}</span>
                                        <v-slider
                                            v-model="taper"
                                            :min="0"
                                            :max="30"
                                            :step="0.1"
                                            :disabled="useStdTable"
                                            class="pr-2 mt-0"
                                        ></v-slider>
                                    </v-flex>
                                    <v-flex xs2 mt-2 mr-2>
                                        <v-text-field
                                            :value="taper"
                                            @change="taper = $event"
                                            class="mt-0"
                                            type="number"
                                            :rules="[rules.requiredNumAllowZero, rules.taper]"
                                            :disabled="useStdTable"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs10 ml-2>
                                        <span class="pl-0">{{ $t("curvature") }}, %</span>
                                        <v-slider
                                            v-model="curvature"
                                            :min="0"
                                            :max="2"
                                            :step="0.1"
                                            class="pr-2 mt-0"
                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                        ></v-slider>
                                    </v-flex>
                                    <v-flex xs2 mt-2 mr-2>
                                        <v-text-field
                                            :value="curvature"
                                            @change="curvature = $event"
                                            class="mt-0"
                                            type="number"
                                            :rules="[rules.requiredNumAllowZero, rules.curvature]"
                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs8 ml-2>
                                        <span class="pl-0">{{ $t("ellipseRatio") }}, %</span>
                                        <v-slider
                                            v-model="ellipseRatio"
                                            :min="0"
                                            :max="10"
                                            :step="0.1"
                                            class="pr-2 mt-0"
                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                            hide-details
                                            dense
                                        ></v-slider>
                                    </v-flex>
                                    <v-flex xs2>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-checkbox
                                                    v-on="on"
                                                    :input-value="rotate == 90"
                                                    @change="rotate = rotate == 0 ? 90 : 0"
                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                    hide-details
                                                >
                                                </v-checkbox>
                                            </template>
                                            <span>{{ $t("rotateLog90deg") }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs2 mt-2 mr-2>
                                        <v-text-field
                                            :value="ellipseRatio"
                                            @change="ellipseRatio = $event"
                                            class="mt-0 pt-0"
                                            type="number"
                                            :rules="[rules.requiredNumAllowZero, rules.ellipse]"
                                            :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                            dense
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <template v-if="calculationForm">
                                    <v-layout flat row>
                                        <v-flex xs12 mr-2>
                                            <v-select
                                                v-model="equipmentId"
                                                :items="equipmentProfiles"
                                                item-text="name"
                                                item-value="id"
                                                :label="$t('equipmentProfile')"
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center align-center>
                                        <v-flex xs10>
                                            {{ $t("usingWane") }}
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-checkbox
                                                v-model="useWane"
                                                :disabled="$store.getters.subscription.settings.optimization.lockWane"
                                                dense
                                                hide-details
                                                class="mt-0"
                                            ></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </template>

                            </v-flex>
                        </template>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="recalculationForm || calculationForm"
                        color="success"
                        @click="recalculateClick"
                    >
                        {{ $t("calculate") }}
                    </v-btn>
                    <v-btn
                        v-else
                        color="success"
                        @click="saveDataClick"
                        :disabled="!name || $refs.PatternVue.diameter == 0"
                    >
                        {{ $t("save") }}
                    </v-btn>
                    <v-btn color="error" @click="close">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box    ref="MessageBox"/>
        <message-dialog ref="MessageDialog"/>
    </v-layout>
</template>

<script>
    import MessageBox    from "./MessageBox";
    import MessageDialog from "./MessageDialog";
    import PatternVue    from "@/components/patterns/PatternVue";
    import Draggable     from "@/plugins/draggable";

    export default {
        name: "EditPatternDialog",

        props: ["showPatternDiameter"],

        components: {
            MessageBox,
            MessageDialog,
            PatternVue
        },

        data () {
            return {
                dialog: false,

                dialogWatcher: null,

                recalculationForm:  false,
                calculationForm:    false,

                boardsHeader: [
                    { text: "Сечение",        value: "size",    align: "left", sortable: true },
                    { text: "Пильный размер", value: "sawSize", align: "left", sortable: true },
                    //{ text: "Длина, м",       value: "length",  align: "left" },
                    //{ text: "Цена за м3",     value: "price",   align: "left", sortable: true },
                ],

                horizontalSaw: 0,
                horizontalSaws: [
                    { text: "Не используется", value: 0 },
                    { text: "1 пила",          value: 1 },
                    { text: "2 пилы",          value: 2 },
                    { text: "3 пилы",          value: 3 },
                    { text: "4 пилы",          value: 4 }
                ],

                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    dTop:      value => (value >= 50 && value <= 999) || this.$t("incorrectValue"),
                    curvature: value => (value >= 0.0 && value <= 2.0) || this.$t("incorrectValue"),
                    ellipse:   value => (value >= 0.0 && value <= 10.0) || this.$t("incorrectValue"),
                    length:    value => (value >= 1 && value <= 10) || this.$t("incorrectValue"),
                    rotate:    value => (value >= -90 && value <= 90) || this.$t("incorrectValue"),
                    taper:     value => (value >= 0 && value <= 30) || this.$t("incorrectValue"),
                    kerf:     value => (value >= 0 && value <= 20) || this.$t("incorrectValue"),
                    requiredNumAllowZero:   value => (!!value || value == 0) || this.$t("requiredField"),
                },

                boardsCentral:         [],
                boardsCentralFiltered: [],
                boardsSide:            [],
                boardsSideFiltered:    [],
                curvature:             0,
                centralBoardsSelected: [],
                dTop:                  null,
                dBottom:               null,
                ellipseRatio:          0,
                equipmentId:            0,
                equipmentProfiles:      [],
                rotate:                0,
                logLength:             0,
                falseCore:             0,
                name:                  "",
                parsedPattern:         {},
                pattern:               {},
                patternId:             0,
                sideBoardsSelected:    [],
                sizeNominal:           true,
                species:               [],
                speciesId:             0,
                symmetricSideBoards:   true,
                splittedPattern:       false,
                dU:                    0,
                taper:                 0,
                volume:                0,
                kerf:                  5,
                draggable:             null,
                rotatePattern:         false,
                patternSolidBG:        false,
                showAxes:              true,
                cancelled:             false,
                recalculate:           null,
                useWane: false,

                groups: [],
                selectedGroupId: 0,
            }
        },

        computed: {
            currentRoute () { return this.$route.path; },

            filter () {
                return this.caseSensitive
                    ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                    : undefined;
            },

            speciesFiltered () {
                return this.species.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id));
            },

            useStdTable () {
                return this.$store.getters.settings.volCalc.method == "standardTables";
            },

            useUserVolumeInput () {
                return this.$store.getters.settings.volCalc.method == "userVolumeInput";
            },
        },

        watch: {
            speciesId: function() { this.loadLumber(); this.loadGroups(); },

            dTop: function(val) {
                this.dBottom = parseInt(val) + parseInt(this.taper * this.logLength);
                this.$refs.PatternVue.updatePattern(this.$refs.PatternVue.patternData);
            },
            taper: function(val) {
                this.dBottom = parseInt(this.dTop) + parseInt(val * this.logLength);
                this.$refs.PatternVue.updatePattern(this.$refs.PatternVue.patternData);
            },

            curvature:      function() { this.$refs.PatternVue.updatePattern(this.$refs.PatternVue.patternData); },
            ellipseRatio:   function() { this.$refs.PatternVue.updatePattern(this.$refs.PatternVue.patternData); },

            symmetricSideBoards: function (val) { localStorage.symmetricSideBoards = val; },
            equipmentId:            function (val) { localStorage.opt1EquipmentId = val; },
            useWane:                function (val) { localStorage.opt1UseWane = val; },

            selectedGroupId: function (val) {
                if (val == 0) {
                    this.boardsCentralFiltered = this.boardsCentral;
                    this.boardsSideFiltered    = this.boardsSide;
                } else {
                    let ids = this.groups.filter(data => data.id == val).length > 0
                        ? this.groups.filter(data => data.id == val)[0].lumberIds
                        : [];
                    this.boardsSideFiltered    = this.boardsSide.filter(data => ids.includes(data.id));
                    this.boardsCentralFiltered = this.boardsCentral.filter(data => ids.includes(data.id));
                }
            },

            dialog (val) {
                let parent = this;

                //if (val == false)
                    //for (var member in this.parsedPattern) delete this.parsedPattern[member];
                if (!val) {
                    this.parsedPattern = {};
                    //this.pattern       = {};
                    /*
                    for (let member in this.parsedPattern) {
                        delete this.parsedPattern[member];
                    }
                    */
                } else {
                    this.getEquipmentProfiles();

                    this.cancelled   = false;
                    this.recalculate = null;

                    //if (!this.isSimplePattern(this.pattern)) {
                    if (this.isComplexPattern(this.pattern)) {
                        //this.showMessageBox(this.$t("unsupportedPattern"), this.$t("unsupportedPatternInfoInEditDialog"));
                        //this.dialog = false;
                        //return;
                        this.splittedPattern = true;
                    } else {
                        this.splittedPattern = false;
                    }

                    this.$refs.PatternVue.updatePattern(this.pattern);

                    //let component = this;

                    //this.draggable = null;
                    this.draggable = new Draggable({
                        onDragEnter: function (container, acceptor) {
                            if (
                                (acceptor.classList.contains("central_board") && !container.classList.contains("central_board"))
                                || (acceptor.classList.contains("side_board") && !container.classList.contains("side_board"))
                            ) {
                                //acceptor.classList.add("denied");
                                acceptor.classList.remove("drag_enter");
                            }
                        },
                        /*
                        onDragStart: function (container, acceptor) {

                            this.$debug.log("onDragStart");
                            this.$debug.log("container");
                            this.$debug.log(container);
                            this.$debug.log("acceptor");
                            this.$debug.log(acceptor);
                            this.$debug.log(acceptor.classList);
                            this.$debug.log(container.attributes);

                        },
                        */
                        onDrop: function (container, acceptor, evt) {
                            /*
                            this.$debug.log("onDrop test successfull");
                            this.$debug.log("container");
                            this.$debug.log(container);
                            this.$debug.log("acceptor");
                            this.$debug.log(acceptor);
                            this.$debug.log(acceptor.classList);
                            this.$debug.log(container.attributes);
                            this.$debug.log("parent");
                            this.$debug.log(parent);
                            */

                            if (acceptor.classList.contains("boards-table")) { // Удаление доски
                                // console.log("delete")
                            /*
                                this.$debug.log(container);
                                this.$debug.log(container.getAttribute("data-index"));
                                this.$debug.log(parent.$refs.PatternVue);
                                this.$debug.log("call removeBoard");
                            */
                                parent.$refs.PatternVue.removeBoard(null, container.getAttribute("data-index"));

                                parent.$refs.PatternVue.removeEmptyContainers(null);
                            /*
                                this.$debug.log("call enum");
                                this.$debug.log(parent.$refs.PatternVue.patternData);
                            */

                                parent.pattern = { ...parent.$refs.PatternVue.getPattern() };
                            } else { // Добавление доски
                                let boardId   = null;
                                let isCentral = acceptor.classList.contains("central_board");

                                for (let i = 0; i < container.attributes.length; i++) {
                                    if (container.attributes[i].nodeName == "data-board") {
                                        boardId = parseInt(container.attributes[i].nodeValue);
                                    }
                                }

                                let boardData = null;

                                if (isCentral) {
                                    parent.boardsCentralFiltered.forEach((board) => {
                                        if (board.id == boardId) {
                                            boardData = board;
                                            boardData.sizeH    = parseInt(board.size.split("x")[0]);
                                            boardData.sizeW    = parseInt(board.size.split("x")[1]);
                                            boardData.sawSizeH = parseFloat(board.sawSize.split("x")[0]);
                                            boardData.sawSizeW = parseFloat(board.sawSize.split("x")[1]);
                                            return;
                                        }
                                    });
                                } else {
                                    parent.boardsSideFiltered.forEach((board) => {
                                        if (board.id == boardId) {
                                            boardData = board;
                                            boardData.sizeH    = parseInt(board.size.split("x")[0]);
                                            boardData.sizeW    = parseInt(board.size.split("x")[1]);
                                            boardData.sawSizeH = parseFloat(board.sawSize.split("x")[0]);
                                            boardData.sawSizeW = parseFloat(board.sawSize.split("x")[1]);
                                            return;
                                        }
                                    });
                                }

                                if (boardData == null) { // Доску тащили из постава, не дотащили
                                    return false;
                                }

                                let newBoard = {
                                    ts: boardData.sawSizeH,
                                    ws: boardData.sawSizeW,
                                    tn: boardData.sizeH,
                                    wn: boardData.sizeW,
                                    vertical: acceptor.classList.contains("vertical") ? 1 : 0
                                }

                                let dropAreaHeight = evt.target.clientHeight;
                                let dropAreaWidth  = evt.target.clientWidth;
                                let droppedAtY     = evt.layerY - evt.target.offsetTop;
                                let droppedAtX     = evt.layerX - evt.target.offsetLeft;
                                let droppedAtTop   = droppedAtY < dropAreaHeight / 2;
                                let droppedAtRight = droppedAtX > dropAreaWidth / 2;
                                //let droppedAtCenter = droppedAtX > dropAreaWidth * 0.25 && droppedAtX < dropAreaWidth * 0.75;

                                if (isCentral) {
                                    if (!parent.splittedPattern) {
                                        droppedAtRight = false;
                                    }

                                    parent.$refs.PatternVue.addCentralBoard(newBoard, droppedAtTop, droppedAtRight);
                                } else {
                                    if (!parent.splittedPattern) {
                                        droppedAtRight = false;
                                        droppedAtTop = false;
                                    }

                                    parent.$refs.PatternVue.addSideBoards(
                                        newBoard,
                                        acceptor.classList.contains("vertical") ? 1 : 2,
                                        acceptor.classList.contains("up") || acceptor.classList.contains("left") ? 1 : 2,
                                        acceptor.classList.contains("vertical") ? droppedAtTop : droppedAtRight
                                    );
                                }
                            }

                            //parent.draggable._addEventListeners();

                            setTimeout(() => { parent.draggable._addEventListeners(); }, 500);
                        }
                    });

                    setTimeout(() => { this.draggable._addEventListeners(); }, 500);
                }
            },
        },

        async mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.equipmentId         = localStorage.opt1EquipmentId ? parseInt(localStorage.opt1EquipmentId) : 0;
            this.symmetricSideBoards = localStorage.symmetricSideBoards   ? JSON.parse(localStorage.symmetricSideBoards) : true;
            this.useWane             = localStorage.opt1UseWane   ? JSON.parse(localStorage.opt1UseWane) : false;

            this.applyLocale();
            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.getSpecies();
            this.getEquipmentProfiles();

            if (!(this.recalculationForm || this.calculationForm)) {
                await this.loadLumber();
                this.loadGroups();
            }

            let user = this.$store.getters.user;

            this.patternSolidBG = user.settings == undefined ? false : user.settings.patternSolidBG;
            //this.rotatePattern  = user.settings == undefined ? false : user.settings.rotatePattern;
            this.showAxes       = user.settings == undefined ? true  : user.settings.showAxes;
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.boardsHeader = [
                    { text: this.$t("dimension"), value: "size",    align: "left", sortable: true },
                    { text: this.$t("sawSize"),   value: "sawSize", align: "left", sortable: true },
                    /*
                    {
                        text:  this.$t("length") + ", " + this.$t("m"),
                        value: "length",
                        align: "left"
                    },
                    */
                    //{ text: this.$t("priceM3"), value: "price", align: "left", sortable: true },
                ],

                this.horizontalSaws = [
                    { text: this.$t("notUsed"),     value: 0 },
                    { text: `1 ${this.$t("saw")}`,  value: 1 },
                    { text: `2 ${this.$t("saws")}`, value: 2 },
                    { text: `3 ${this.$t("saws")}`, value: 3 },
                    { text: `4 ${this.$t("saws")}`, value: 4 }
                ];

                this.species.forEach((item) => {
                    item.name = this.$t(item.original);
                });
            },

            /**
             * Очистка постава
             */
            clearPattern () {
                this.$refs.PatternVue.reset();
                let emptyPattern = {
                    dlimitmin: 140,
                    dlimitmax: 220,
                    dmin: 140,
                    dmax: 220,
                    du: 16,
                    kerf: 5,
                    order: 1,
                    species: "spruce",
                    v: 2,
                    vertical: 0,
                    meta: {
                        isBoard: false,
                        isVertical: true,
                        showNominal: true,
                        xSize: 104,
                        ySize: 103
                    },
                    items: []
                };

                this.$refs.PatternVue.updatePattern(emptyPattern);
            },

            /**
             * Проверка на сложный постав
             *
             * @param {object} pattern Постав или часть постава
             *
             * @returns {boolean}
             */
            isComplexPattern (pattern) {
                let vertical = pattern.vertical;
                let result = false;

                if (!pattern.hasOwnProperty("items")) {
                    result = false;
                } else {
                    let sameVertical    = true;
                    let sameBoardsCount = 0;

                    pattern.items.forEach(item => {
                        if (item.vertical !== vertical) {
                            sameVertical = false;
                        } else {
                            sameBoardsCount += item.hasOwnProperty("items") ? 0 : 1;
                        }
                    });

                    if (sameVertical) {
                        result = sameBoardsCount > 1; //true;
                    } else {
                        pattern.items.forEach(item => {
                            if (this.isComplexPattern(item)) {
                                result = true;
                            }
                        });
                    }
                }

                return result;
            },

            /**
             * Возвращает истину если постав является простым
             *
             * @param {object} pattern Постав
             *
             * @returns {boolean}
             */
            /*
            isSimplePattern (pattern) {
                const obj = JSON.parse(JSON.stringify(pattern));

                if (obj.order == 1) {
                    for (let item1 of obj.items) {
                        if (item1.order == 1) {
                            return false;
                        }
                        if (item1.order == 2) {
                            for (let item2 of item1.items) {
                                if (item2.order == 2) {
                                    return false;
                                }
                                if (item2.order == 0) {
                                    for (let item0 of item2.items) {
                                        if (item0.order == -1) {
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                        if (item1.order == 0) {
                            for (let item0 of item1.items) {
                                if (item0.order == -1) {
                                    return false;
                                }
                            }
                        }
                    }
                }

                if (obj.order == 2) {
                    for (let item2 of obj.items) {
                        if (item2.order == 2) {
                            return false;
                        }
                        if (item2.order == 0) {
                            for (let item0 of item2.items) {
                                if (item0.order == -1) {
                                    return false;
                                }
                            }
                        }
                    }
                }

                if (obj.order == 0) {
                    for (let item0 of obj.items) {
                        if (item0.order == -1) {
                            return false;
                        }
                    }
                }

                return true;
            },
            */

            /**
             * Обработчик изменения элемента выбора породы
             *
             * @param {number} val Значение
             */
            inputSpecies (val) {
                let oldVal = this.speciesId;
                //let curPattern = { ...this.pattern };
                //let curParsedPattern = { ...this.parsedPattern };

                if (this.$refs.PatternVue.patternData.items.length == 0) {
                    this.speciesId = val;

                    this.clearPattern();
                    this.$forceUpdate();
                } else {
                    // Удаление наблюдателя если установлен
                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                    let speciesId = val;
                    // Отслеживание нажатия кнопки ok в диалоге
                    this.dialogWatcher = this.$watch(
                        "$refs.MessageDialog.answer",
                        (val) => {
                            if (val) {
                                this.speciesId = speciesId;

                                this.clearPattern();
                            } else {
                                this.speciesId = 0;

                                setTimeout(() => {
                                    this.speciesId = oldVal;
                                }, 100);
                            }
                            this.$forceUpdate();
                        }
                    );
                    this.$refs.MessageDialog.title       = this.$t("speciesSwitch");
                    this.$refs.MessageDialog.messageText = this.$t("speciesSwitchRequest");
                    this.$refs.MessageDialog.dialog      = true;
                }
            },

            /**
             * Загрузка групп пиломатериалов
             */
             loadGroups () {
                this.axios.get(`${this.$config.apiURL}lumber_groups/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let groups = response.data.groups;

                            this.groups = [];

                            this.groups.push({
                                id:        0,
                                name:      this.$t("noGroup"),
                                speciesId: this.speciesId,
                                lumberIds: [],
                            });

                            groups.forEach((item) => {
                                if (item.Species.id == this.speciesId) {
                                    let lumberIds = [];
                                    item.LumberGroupsData.forEach(data => {
                                        lumberIds.push(parseInt(data.LumberId));
                                    });
                                    this.groups.push({
                                        id:        item.id,
                                        name:      item.Name,
                                        speciesId: item.Species.id,
                                        lumberIds: lumberIds,
                                    });
                                }
                            });
                        }

                    })
                    .catch(error => {

                        this.$debug.error(error);

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData"));
                        }
                    });
            },

            /**
             * Загрузка справочника пиломатериалов
             */
            loadLumber () {
                this.axios.get(`${this.$config.apiURL}lumber/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lumberInfo = response.data.lumber;

                            this.boardsCentral = [];
                            this.boardsSide    = [];

                            lumberInfo.forEach((item) => {
                                let lengthsList = "";

                                JSON.parse(item.LengthsJSON).forEach((lenItem, index) => {
                                    lengthsList += index ? ", " : "";
                                    lengthsList += lenItem.length.slice(0, -2);
                                });

                                // Меняем значения стандартных сечений на ознакомительной подписке
                                if (this.$store.getters.subscription.id == 1) {
                                    item.Tn += 2;
                                    item.Wn += 2;
                                    item.Ts = parseFloat(item.Ts) + 2;
                                    item.Ws = parseFloat(item.Ws) + 2;
                                }

                                if (item.BoardType && this.speciesId == item.Species.id) {
                                    this.boardsSide.push({
                                        id:      item.id,
                                        uid:     item.BoardType ? "s" + item.id : "c" + item.id,
                                        size:    item.Tn + " x " + item.Wn,
                                        sawSize: item.Ts + " x " + item.Ws,
                                        length:  lengthsList,
                                        price:   item.Price,
                                        expenses:   item.Expenses == undefined ? 0 : item.Expenses
                                    });
                                } else if (this.speciesId == item.Species.id) {
                                    this.boardsCentral.push({
                                        id:      item.id,
                                        uid:     item.BoardType ? "s" + item.id : "c" + item.id,
                                        size:    item.Tn + " x " + item.Wn,
                                        sawSize: item.Ts + " x " + item.Ws,
                                        length:  lengthsList,
                                        price:   item.Price,
                                        expenses:   item.Expenses == undefined ? 0 : item.Expenses
                                    });
                                }
                            });

                            this.boardsCentralFiltered = this.boardsCentral;
                            this.boardsSideFiltered    = this.boardsSide;
                        }

                        if (this.draggable && this.draggable._addEventListeners) {
                            setTimeout(() => { this.draggable._addEventListeners(); }, 500);
                        }
                    })
                    .catch(err => {
                        this.$refs.MessageBox.title       = this.$t("error");
                        this.$refs.MessageBox.messageText = this.$t("cantLoadLumberData");
                        this.$refs.MessageBox.dialog      = true;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `EditPatternDialog.vue -> loadLumber: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Загразка пород
             */
            getSpecies () {
                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.species = [];

                            speciesInfo.forEach((item) => {
                                this.species.push({
                                    id:   item.id,
                                    name: this.$t(item.Name),
                                    original: item.Name,
                                });
                                if (this.speciesId == 0) {
                                    this.speciesId = item.id;
                                }
                            });
                        }
                    })
                    .catch(err => {
                        this.$refs.MessageBox.title       = this.$t("error");
                        this.$refs.MessageBox.messageText = this.$t("cantLoadSpeciesData");
                        this.$refs.MessageBox.dialog      = true;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `EditPatternDialog.vue -> getSpecies: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Получение данных о профилях оборудования
             */
             getEquipmentProfiles () {
                this.axios.get(`${this.$config.apiURL}lines/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let profilesInfo = response.data.lines

                            this.equipmentProfiles = [];

                            profilesInfo.forEach((profileInfo) => {
                                this.equipmentProfiles.push({
                                    id:   profileInfo.id,
                                    name: profileInfo.Name,
                                    data: JSON.parse(profileInfo.DataJSON)
                                });
                            });

                            if (this.equipmentId == 0 && !localStorage.opt1EquipmentId) {
                                this.equipmentId = (profilesInfo.length == 0) ? 0 : this.equipmentProfiles[0].id;
                            }
                        }
                    })
                    .catch(err => {
                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Optimization.vue -> getEquipmentProfiles: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentProfiles") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentProfiles") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadEquipmentProfiles"));
                        }
                    });
            },

            /**
             * Обработчик нажатия кнопки сохранения данных
             */
            async saveDataClick () {
                let pattern = this.$refs.PatternVue.getPattern();

                pattern.species = this.species[this.speciesId-1].original;

                delete pattern.info;

                if (!this.$obj.isEmpty(this.parsedPattern)) {
                    await this.axios({
                        method: "patch",
                        url: `${this.$config.apiURL}patterns/${this.parsedPattern.id}/`,
                        data: {
                            speciesId: this.speciesId,
                            species:   this.species[this.speciesId-1].original,
                            name:      this.name,
                            Du:        parseInt(this.dU),
                            Dmin:      pattern.dmin,
                            Dmax:      pattern.dmax,
                            DLimitMin: pattern.dlimitmin,
                            DLimitMax: pattern.dlimitmax,
                            Visible:   true,
                            DataJSON:  JSON.stringify(pattern)
                        },
                        withCredentials: true
                    }).catch(err => {
                        this.$refs.MessageBox.title       = this.$t("error");
                        this.$refs.MessageBox.messageText = this.$t("cantSavePattern");
                        this.$refs.MessageBox.dialog      = true;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `EditPatternDialog.vue -> saveDataClick: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
                } else {
                    await this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}patterns/`,
                        data: {
                            speciesId: this.speciesId,
                            species:   this.species[this.speciesId-1].original,
                            name:      this.name,
                            Du:        parseInt(this.dU),
                            Dmin:      pattern.dmin,
                            Dmax:      pattern.dmax,
                            DLimitMin: pattern.dlimitmin,
                            DLimitMax: pattern.dlimitmax,
                            Visible:   true,
                            DataJSON:  JSON.stringify(pattern)
                        },
                        withCredentials: true
                    }).catch(err => {
                        this.$refs.MessageBox.title       = this.$t("error");
                        this.$refs.MessageBox.messageText = this.$t("cantSavePattern");
                        this.$refs.MessageBox.dialog      = true;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `EditPatternDialog.vue -> saveDataClick: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
                }

                this.dialog = false;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            recalculateClick () {
                this.pattern = JSON.parse(JSON.stringify(this.$refs.PatternVue.patternData));
                this.recalculate = true;
                this.dialog = false;
            },

            close () {
                this.recalculate = false;
                this.dialog = false;
            },

        }
    }
</script>

<style lang="sass" scoped>
    $side-size: 440px

    #drop_area, .drop, .pattern,
    #drop_area > .drop > .layout.row.wrap,
    #drop_area > .pattern-container
        width: $side-size !important
        height: $side-size !important

    .drop-area
        margin-top: 24px
        margin: auto

        >
            .drop
                z-index: -1
                >
                    .layout.row.wrap
                        .layout.row.wrap
                            height: $side-size

                &.visible
                    z-index: 1

    .drag_drop
        >.v-icon
            position: absolute
            z-index: -1
            display: none
            color: rgb(59, 128, 13)
            font-size: 40px

        &.drag_enter
            border: dashed 1px rgba(19, 197, 19, .25)
            background: dashed rgba(19, 197, 19, .05)
            background-size: cover
        &.denied.drag_enter
            border: dashed 1px rgba(255, 0, 0, .25)
            background: dashed rgba(255, 0, 0, .05)
            background: repeating-linear-gradient(-45deg, rgba(255, 0, 0, .25), rgba(255, 0, 0, .25) 5px, transparent 5px, transparent 10px)
            background-size: cover
        &.central_board
            .central
                left: 45%
            .up
                top: 34%
            .down
                bottom: 34%
            .right
                right: 34%
            .left
                left: 34%
            &.drag_enter
                background: repeating-linear-gradient(-45deg, rgba(19, 197, 19, .25), rgba(19, 197, 19, .25) 5px, transparent 5px, transparent 10px), linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(256, 256, 256, 0.5) 50%)
                .up, .down, .right, .left, .central
                    display: block
        &.side_board
            &.vertical
                .central
                    top: 45%
                .up
                    top: 23%
                .down
                    bottom: 23%
                .right
                    right: 7%
                .left
                    left: 7%

            &.horizontal
                .central
                    left: 45%
                .up
                    top: 7%
                .down
                    bottom: 7%
                .right
                    right: 34%
                .left
                    left: 34%
            &.drag_enter
                background: repeating-linear-gradient(-45deg, rgba(19, 197, 19, .25), rgba(19, 197, 19, .25) 5px, transparent 5px, transparent 10px)
                .up, .down, .right, .left, .central
                    display: block
    .left-border
        border-left: 2px solid grey

    .dimensions-list
        overflow-x: auto
        max-height: $side-size px
        margin-bottom: 16px
        max-height: 380px

    .pattern-container
        position: absolute
        box-sizing: border-box
        border: 1px solid #aaa
        display: inline-block
        padding: 4px

    .pattern
        position: absolute
        left: 0
        top: 0

    .transparent-bg
        background-color: transparent
</style>
